import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';
import Anchor from '../../../../commonComponents/Anchor';
import Progress from '../../../academy/list/enrolledItem/Progress';
import GameProp from '../../../challenges/propTypes/gameProp';
import { GAME_TYPE } from '../../../../services/utilityFunctions';

function ChallengeCarouselItem({ t, game }) {
  const { isBoosted } = game;
  const image = game.imageSquare || game.image;
  const imageURL =
    image && image.thumb ? image.thumb : '/images/no_image_upload.png';
  const isCandidates =
    game.gameType && game.gameType.type === GAME_TYPE.CANDIDATES;
  return (
    <div
      className={`challenge-carousel-item ${
        isBoosted ? 'highlight-challenge' : ''
      }`}
    >
      <div className="challenge-carousel-item-img">
        <img src={imageURL} alt={game.title} />
      </div>
      <div className="challenge-carousel-item-content">
        <h5>{game.name}</h5>
        <div className="row">
          <div className="col-lg-12 col-12">
            {isCandidates ? (
              <div className="recommendation-progress">{`${
                game.candidates || 0
              } | 6`}</div>
            ) : (
              <Progress progress={game.progress < 0 ? 0 : game.progress} />
            )}
          </div>
        </div>
        {game?.challenges?.isViewSimplified !== true && (
          <div className="challenge-carousel-item-anchor">
            <Anchor
              href={`/challenges/${game._id}`}
              className="btn m-btn--pill btn-dynamic navigation-button"
            >
              {t('continue')}
            </Anchor>
          </div>
        )}
      </div>
    </div>
  );
}

ChallengeCarouselItem.propTypes = {
  t: PropTypes.func.isRequired,
  game: PropTypes.shape(GameProp.propType).isRequired,
};

ChallengeCarouselItem.defaultProps = {};

export default translate(ChallengeCarouselItem);
